@if (sdaInformations) {
<div class="sda-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Sda.Title' | translate }} {{ sdaInformations.number ? '"' + sdaInformations.number + '"' : sdaInformations.id ? '"' + sdaInformations.id + '"' : '' }}</span>
    </div>

    <div class="content">
        @if (sdaInformations !== undefined) {
        <form [formGroup]="sdaForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Sda.NumberPlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="number" autocomplete="off" [required]="isCreation" [readonly]="!isCreation" />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Sda.TargetTypePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="targetType" (valueChange)="targetTypeChange($event)">
                                    @for (targetType of targetTypes; track targetType) {
                                    <mat-option [value]="targetType">
                                        {{ 'EnumSdaTargetTypes.' + targetType | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        @if (sdaForm.get('targetType').value === sdaTargetTypes.extension) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'Sda.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="extension" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayExtension" (optionSelected)="extensionsChange($event)">
                                    @for (extension of extensionsOptions | async; track extension) {
                                    <mat-option [value]="extension">
                                        {{ extension | extensionDisplay }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        } @if (sdaForm.get('targetType').value === sdaTargetTypes.service) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'Sda.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="service" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayService" (optionSelected)="servicesChange($event)">
                                    @for (service of servicesOptions | async; track service) {
                                    <mat-option [value]="service">
                                        {{ service.name }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        }
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button color="accent" type="button" routerLink="/sdas">{{ 'Sda.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!sdaForm.valid" type="submit">{{ 'Sda.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
